import { render, staticRenderFns } from "./languageSelector.vue?vue&type=template&id=13839cfc&scoped=true&"
import script from "./languageSelector.vue?vue&type=script&lang=js&"
export * from "./languageSelector.vue?vue&type=script&lang=js&"
import style0 from "./languageSelector.vue?vue&type=style&index=0&id=13839cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13839cfc",
  null
  
)

export default component.exports